import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => ({
  root: {
    display: "inline-flex",
    alignItems: "center",
    height: 28,
    paddingLeft: 8,
    paddingRight: 8,
    borderStyle: "solid",
    borderWidth: 1,
    fontSize: 14,
    lineHeight: "normal",
    margin: 2,
    whiteSpace: "nowrap"
  },
  alert: {
    borderColor: theme.palette.error.main,
    color: theme.palette.error.main
  }
}));
